export default __webpack_public_path__ + "static/media/skype_icon.522cdb4d.svg";